import * as React from "react"
import Header from "./header"
import Footer from "./footer"
import Head from "./head"
import "../styles.css"
import Scroll from "./scroll"

const Layout = (props) => {
  let maxIndex = 0
  if (props.children?.length > 0) {
    maxIndex = props.children.length - 1
  }
  return (
    <>
      <Head {...props} />
      <Header />
      <Scroll showBelow={400} />
      {props.children && props.children}
      <Footer maxIndex={maxIndex} />
    </>
  )
}

export default Layout
